import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { TimelineScrambleView } from "../views/timelineScrambleView";
import quizData from "../data/timelineData.json";
import { arrayMove } from "@dnd-kit/sortable";
import { updateProgressReduxCB } from "../util/helpersFunction.js";
import locationInfo from "../data/locationInfo.json";

function TimelineScramble() {
  const { id, mode } = useParams();
  const imageKey = `drawing_${id}`;
  const location = locationInfo[id];
  const title = location?.title;

  const events = quizData[id] || [];
  const correctOrder = events.map((e) => e.id);

  const [items, setItems] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [currentStep, setCurrentStep] = useState(3);

  useEffect(() => {
    setItems(shuffleArrayCB(events));
    setIsChecked(false);
  }, [id]);

  function shuffleArrayCB(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }
  const quest = "timelineScramble";


  function handleContinueACB() {
    if (mode && id) {
      const status = "success";
      updateProgressReduxCB(id, mode, status, quest);
      window.location.hash = `#/questComplete/${id}/${mode}/${quest}`;

     
    } else {
      console.warn("Mode or ID is undefined");
    }
  }

  function handleDragEndACB(event) {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = items.findIndex((i) => i.id === active.id);
      const newIndex = items.findIndex((i) => i.id === over.id);
      setItems(arrayMove(items, oldIndex, newIndex));
    }
  }

  function handleCheckACB() {
    setIsChecked(true);
    setCurrentStep(4); // advance progress bar
  }

  return (
    <TimelineScrambleView
      mode={mode}
      title={title}
      items={items}
      onCheck={handleCheckACB}
      isChecked={isChecked}
      correctOrder={correctOrder}
      onComplete={handleContinueACB}
      onDragEnd={handleDragEndACB}
      currentStep={currentStep}
      imageKey={imageKey}
    />
  );
}

export { TimelineScramble };
